import { CustomImage } from './custom-image';

export * from './custom-image';

export default CustomImage;
